var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-select',{ref:"select",attrs:{"async":"","emit-only-value":false,"search-data":_vm.search,"parse-callback":_vm.parse,"enable-photo":"","enable-profile":"","profile-placeholder":"Não definido"},on:{"input":(v) => _vm.$emit('input', v)},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }